__turbopack_context__.v({
  "active": "style-module-scss-module__66DBhG__active",
  "bottom": "style-module-scss-module__66DBhG__bottom",
  "container": "style-module-scss-module__66DBhG__container",
  "content": "style-module-scss-module__66DBhG__content",
  "contentFirst": "style-module-scss-module__66DBhG__contentFirst",
  "contentItem": "style-module-scss-module__66DBhG__contentItem",
  "contentWrapper": "style-module-scss-module__66DBhG__contentWrapper",
  "fullView": "style-module-scss-module__66DBhG__fullView",
  "left": "style-module-scss-module__66DBhG__left",
  "media": "style-module-scss-module__66DBhG__media",
  "mediaFirst": "style-module-scss-module__66DBhG__mediaFirst",
  "mediaItem": "style-module-scss-module__66DBhG__mediaItem",
  "right": "style-module-scss-module__66DBhG__right",
  "splitView": "style-module-scss-module__66DBhG__splitView",
  "textShadow": "style-module-scss-module__66DBhG__textShadow",
  "top": "style-module-scss-module__66DBhG__top",
  "whiteContentBackground": "style-module-scss-module__66DBhG__whiteContentBackground",
});
